export default __webpack_public_path__ + "static/media/icon3.660e476c.svg";